import { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import './AdminHome.css';
import { AdminMobileMenu } from './AdminMobileMenu';
import { AdminSidebar } from './AdminSidebar';
import { getActiveAdminTab } from './adminTabs';
import { AdminIcon } from '../../Icons/AdminIcon';
import { Icon } from '../../Icons/Icon';

export const AdminShell = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = getActiveAdminTab(location.pathname);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="admin-layout">

      {/* MOBILE HEADER */}
      <div className="admin-mobile-header">
        <div className="admin-mobile-title">
          <AdminIcon.CheckCircle />
          <span>Adminpanel</span>
        </div>
        <button
          type="button"
          className="admin-mobile-toggle"
          aria-label={mobileOpen ? 'Stäng meny' : 'Öppna meny'}
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <AdminIcon.CrossClose fill="currentColor" /> : <Icon.MenuIcon />}
        </button>
      </div>

      {/* MOBILE MENU */}
      {mobileOpen && (
        <AdminMobileMenu
          activeTab={activeTab}
          onNavigate={(path) => {
            navigate(path);
            setMobileOpen(false);
          }}
        />
      )}

      {/* DESKTOP SIDEBAR */}
      <AdminSidebar
        activeTab={activeTab}
        onNavigate={navigate}
      />

      {/* CONTENT */}
      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
};
